// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.venue-item {
  background: #ffffff;
  border: 0.8px solid #262626;
  padding: 16px 20px;
  transition: 0.3s linear, opacity 1s ease-in-out;
  text-align: left;
  border-radius: 20px;
  cursor: pointer;
  min-height: auto;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  margin: 0 10px 10px 10px; /* Add margin for spacing in swiper/list */
}
@media (min-width: 991px) {
  .venue-item {
    padding: 16px;
    border-radius: 20px;
    margin: 0;
    box-shadow: none;
    margin-bottom: 20px;
  }
}
.venue-item .venue-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
}
.venue-item .left-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  padding-right: 5px;
}
.venue-item .right-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-end;
  text-align: right;
  padding-left: 5px;
}
.venue-item .header-info {
  margin-bottom: 12px;
}
.venue-item .header-info .venue-id {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  margin-bottom: 2px;
}
.venue-item .header-info .name {
  font-family: var(--font-family-sans);
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: #262626;
  text-transform: uppercase;
  margin: 0;
}
.venue-item .hours-block {
  font-family: AppFont, sans-serif;
  font-size: 13px;
  color: #262626;
  line-height: 1.4;
}
.venue-item .action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-bottom: 15px;
}
.venue-item .action-btn {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  border-radius: 300px;
  font-family: var(--font-family-sans);
  font-weight: 700;
  font-size: 13px;
  text-transform: none;
  cursor: pointer;
  transition: all 0.2s;
  background: #ffffff;
  color: #262626;
  border: 1px solid #b0a572;
}
.venue-item .action-btn.active {
  background: #b0a572;
  color: #ffffff;
  border-color: #b0a572;
}
.venue-item .action-btn:active {
  opacity: 0.8;
}
.venue-item .action-btn.pickup-btn {
  background: #B0A572;
  color: #ffffff;
}
.venue-item .address-block {
  text-align: left;
}
.venue-item .address-block .address-name {
  font-family: var(--font-family-montserrat);
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
  text-transform: none;
  margin-bottom: 2px;
}
.venue-item .address-block .address-text {
  font-family: var(--font-family-montserrat);
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/components/venue-suggestion/venue-suggestion.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,wBAAA,EAAA,0CAAA;AADD;ACVE;EDCF;IAaE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;IACA,mBAAA;EAAA;AACF;AAOA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AALD;AAQA;EACC,aAAA;EACA,sBAAA;EACA,OAAA;EACA,uBAAA;EACA,kBAAA;AAND;AASA;EACC,aAAA;EACA,sBAAA;EACA,OAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;AAPD;AAWA;EACC,mBAAA;AATD;AAUC;EACC,gCAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AARF;AAUC;EACC,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,SAAA;AARF;AAYA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAVD;AAcA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAZD;AAeA;EACC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EAEA,mBAAA;EACA,cAAA;EACA,yBAAA;AAdD;AAgBC;EACC,mBAAA;EACA,cAAA;EACA,qBAAA;AAdF;AAiBC;EACC,YAAA;AAfF;AAiBC;EACC,mBAAA;EACA,cAAA;AAfF;AAoBA;EACC,gBAAA;AAlBD;AAmBC;EACC,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;AAjBF;AAmBC;EACC,0CAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAjBF","sourcesContent":["@import \"../../../theme/mixins.scss\";\n\n.venue-item {\n\tbackground: #ffffff;\n\tborder: 0.8px solid #262626;\n\tpadding: 16px 20px;\n\ttransition: 0.3s linear, opacity 1s ease-in-out;\n\ttext-align: left;\n\tborder-radius: 20px;\n\tcursor: pointer;\n\tmin-height: auto;\n\tbox-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); \n\tmargin: 0 10px 10px 10px; /* Add margin for spacing in swiper/list */\n\n\t@include desktop {\n\t\tpadding: 16px;\n\t\tborder-radius: 20px;\n\t\tmargin: 0;\n\t\tbox-shadow: none;\n\t\tmargin-bottom: 20px;\n\t}\n\t&.selected {\n\t\t// highlight if needed\n\t}\n\n// New Layout Styles\n// New Layout Styles\n.venue-content {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\tgap: 15px;\n\twidth: 100%;\n}\n\n.left-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\talign-items: flex-start;\n\tpadding-right: 5px;\n}\n\n.right-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\talign-items: flex-end;\n\ttext-align: right;\n\tpadding-left: 5px;\n}\n\n// Typography\n.header-info {\n\tmargin-bottom: 12px;\n\t.venue-id {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 14px;\n\t\tcolor: #000;\n\t\tmargin: 0;\n\t\tmargin-bottom: 2px;\n\t}\n\t.name {\n\t\tfont-family: var(--font-family-sans);\n\t\tfont-weight: 700;\n\t\tfont-size: 24px;\n\t\tline-height: 1.2;\n\t\tcolor: #262626;\n\t\ttext-transform: uppercase;\n\t\tmargin: 0;\n\t}\n}\n\n.hours-block {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 13px;\n\tcolor: #262626;\n\tline-height: 1.4;\n}\n\n// Action Buttons\n.action-buttons {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\twidth: 100%;\n\tmargin-bottom: 15px;\n}\n\n.action-btn {\n\twidth: 100%;\n\tpadding: 10px 0;\n\ttext-align: center;\n\tborder-radius: 300px;\n\tfont-family: var(--font-family-sans);\n\tfont-weight: 700;\n\tfont-size: 13px;\n\ttext-transform: none;\n\tcursor: pointer;\n\ttransition: all 0.2s;\n\t\n\tbackground: #ffffff;\n\tcolor: #262626;\n\tborder: 1px solid #b0a572;\n\n\t&.active {\n\t\tbackground: #b0a572;\n\t\tcolor: #ffffff;\n\t\tborder-color: #b0a572;\n\t}\n\n\t&:active {\n\t\topacity: 0.8;\n\t}\n\t&.pickup-btn {\n\t\tbackground: #B0A572;\n\t\tcolor: #ffffff;\n\t}\n}\n\n// Address\n.address-block {\n\ttext-align: left;\n\t.address-name {\n\t\tfont-family: var(--font-family-montserrat);\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\ttext-transform: uppercase;\n\t\tmargin: 0;\n\t\ttext-transform: none;\n\t\tmargin-bottom: 2px;\n\t}\n\t.address-text {\n\t\tfont-family: var(--font-family-montserrat);\n\t\tfont-size: 14px;\n\t\tmargin: 0;\n\t\tline-height: 1.4;\n\t}\n}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
